module.exports = __webpack_public_path__ + "img/work1.6fd9b475.svg";